import { useAuth0 } from '@auth0/auth0-react'
import { useCallback, useEffect } from 'react'

import { getAuthBlockedUserToastActions } from '../../../components/auth/BlockedUserToastActions'
import useSiteSettings from '../../../hooks/useSiteSettings'
import { usePersistentToast } from '../../toasts/hooks/usePersistentToast'
import { isInvalidStateError, isUserBlockedError } from '../utils'

export const useBlockedUserToast = () => {
  const { blockedUserErrorMessage } = useSiteSettings() || {}
  const { error } = useAuth0()
  const isInvalidState = isInvalidStateError(error)
  const isUserBlocked = isUserBlockedError(error)

  const condition = useCallback(
    () => isUserBlocked && !isInvalidState,
    [isInvalidState, isUserBlocked],
  )

  const { shouldShowToast, shouldHideToast, hideToast, showToast, dismissToast } =
    usePersistentToast({
      toastId: 'auth0-blocked-user',
      condition,
      excludedPathPatterns: [/^\/account/],
    })

  useEffect(() => {
    if (shouldShowToast) {
      showToast(
        blockedUserErrorMessage ??
          'Contact customer service for support as your account is currently on hold',
        {
          variant: 'error',
          action: getAuthBlockedUserToastActions({ dismissToast }),
        },
      )
    }
  }, [blockedUserErrorMessage, shouldShowToast, dismissToast, showToast])

  useEffect(() => {
    if (shouldHideToast) {
      hideToast()
    }
  }, [shouldHideToast, hideToast])
}
